// maybe remove cookies on language switch?
// localStorage.removeItem(cookiesPrefix + 'SetCookies');
// localStorage.removeItem(cookiesPrefix + 'Cookies');

// if using history navigation, do cookiesDoSetIframes in setPage!!!

// imports --------------------------------------------------------------------
import * as Vars from './0-vars.js';
import * as Resize from './4-resize.js';
import * as Scroll from "./5-scroll.js";
import * as VideoEmbed from './6-video-embed-v2.5.js';

// set user variables ----------------------------------------------------------
// exported variables ---------------------------------------------------------
export const cookiesPrefix = 'hm'; // for instance a project code

// local variables ------------------------------------------------------------
const cookiesBlockPage = true; // do the cookies overlay the entire page?
const cookiesCursorEl = document.querySelector('.cookies-cursor');

// set default variables -------------------------------------------------------
// exported variables ---------------------------------------------------------
export let cookiesAcceptIframes = true; // when there is no cookie popup, iframes are allowed

// local variables ------------------------------------------------------------
let cookiesSetIframes = false; // so you know if applying cookies should reset video embeds
const cookiePopover1El = document.querySelector('.popover--cookies-1');
const cookiePopover2El = document.querySelector('.popover--cookies-2');

// initCookies function -----------------------------------------------------------
// do these things only once and before setPage (because of video-embed setting)
export const initCookies = () => {
  // console.log('initCookies');
  document.body.addEventListener('click', event => {
    let el = event.target.closest('.blocked-iframe__button');
    if (el) {
      if (cookiePopover2El) cookiePopover2El.classList.add('popover--active');
      if ('checkBlockScroll' in Scroll) Scroll.checkBlockScroll();
    }

    el = event.target.closest('.cookies .toggle__btn');
    if (el) {
      const toggleEl = el.closest('.toggle');
      if (toggleEl) toggleEl.classList.toggle('toggle--off');
    }

    let acceptAllSelector = '.js-cookies-accept-all';
    if (cookiesCursorEl && !Vars.blTouch) {
      acceptAllSelector += ', .popover--cookies-1 .popover__bg-btn';
      acceptAllSelector += ', .popover--cookies-2 .popover__bg-btn';
    }

    el = event.target.closest(acceptAllSelector);
    if (el) {
      localStorage.setItem(cookiesPrefix + 'SetCookies', 1);

      for (let i = 0; i < $cookies.length; i++) {
        $cookies[i].accepted = true;
      }

      localStorage.setItem(cookiesPrefix + 'Cookies', JSON.stringify($cookies));

      checkReload();
    }

    el = event.target.closest('.js-cookies-reject-all');
    if (el) {
      localStorage.setItem(cookiesPrefix + 'SetCookies', 1);

      for (let i = 0; i < $cookies.length; i++) {
        $cookies[i].accepted = false;
      }

      localStorage.setItem(cookiesPrefix + 'Cookies', JSON.stringify($cookies));

      checkReload();
    }

    el = event.target.closest('.cookies__settings, .js-cookies-btn');
    if (el && cookiePopover1El && cookiePopover2El) {
      cookiePopover1El.classList.remove('popover--active');
      cookiePopover2El.classList.add('popover--active');
      if ('checkBlockScroll' in Scroll) Scroll.checkBlockScroll();
    }

    el = event.target.closest('.cookies__selected');
    if (el) {
      localStorage.setItem(cookiesPrefix + 'SetCookies', 1);

      const cookieToggleEls = document.querySelectorAll('.cookies .toggle');
      if ($cookies) {
        for (let i = 0; i < $cookies.length; i++) {
          if (cookieToggleEls[i] && cookieToggleEls[i].classList.contains('toggle--off')) {
            $cookies[i].accepted = false;
          } else {
            $cookies[i].accepted = true;
          }
        }
      }

      localStorage.setItem(cookiesPrefix + 'Cookies', JSON.stringify($cookies));

      checkReload();
    }
  });

  if (cookiesCursorEl) {
  // mouse and keyboard --------------------------------
    // mouseout, focusout listeners
    const outHandler = event => {
      if (Vars.blTouch) return;
      let el = event.target.closest('.popover--cookies-1 .popover__bg-btn, .popover--cookies-2 .popover__bg-btn');
      if (el) cookiesCursorEl.classList.remove('cookies-cursor--active');
    };

    document.body.addEventListener('mouseout', outHandler); // doesn't bubble, triggers on touch

    // mouseover, focusin listeners
    const inHandler = event => {
      if (Vars.blTouch) return;
      let el = event.target.closest('.popover--cookies-1 .popover__bg-btn, .popover--cookies-2 .popover__bg-btn');
      if (el) cookiesCursorEl.classList.add('cookies-cursor--active');
    };

    document.body.addEventListener('mouseover', inHandler); // doesn't bubble, triggers on touch

    // mouse move listener
    document.body.addEventListener('mousemove', event => {
      const x = event.clientX;
      const y = event.clientY;

      const el = event.target.closest('.popover--cookies-1 .popover__bg-btn, .popover--cookies-2 .popover__bg-btn');
      if (el) cookiesCursorEl.style.transform = `translate(${x}px, ${y}px)`;
    });
  }

  const cookiesEl = document.querySelector('.cookies');
  if (!cookiesEl) return;

  // functional cookies
  cookiesAddHTML($cookiesFunctional.head);
  cookiesAddHTML($cookiesFunctional.body);

  // so it's done before body fix, when it can still be done
  Resize.setResize(true);

  // additional cookies
  if (localStorage.getItem(cookiesPrefix + 'SetCookies') === null) {
    // console.log('additional cookies not set prevously');

    showCookies();
  } else if (typeof $cookies != 'undefined') {
    // console.log('additional cookies are set previously', {$cookies});

    // get saved cookies
    const jsonCookies = JSON.parse(localStorage.getItem(cookiesPrefix + 'Cookies'));

    // compare saved and cms cookies
    if ($cookies.length == jsonCookies.length) {
      let cookiesChanged = false;
      for (let i = 0; i < $cookies.length; i++) {
        if ($cookies[i].head != jsonCookies[i].head || $cookies[i].body != jsonCookies[i].body) {
          cookiesChanged = true;
          break;
        }
      }

      // console.log({cookiesChanged});

      if (cookiesChanged) {
        showCookies();
      } else {
        $cookies = jsonCookies; // get accepted boolean per cookie
        applyCookies();
      }
    } else {
      // new length, show cookies
      showCookies();
    }
  }
};

// functions -------------------------------------------------------------------
const showCookies = () => {
  // console.log('showCookies');

  if (cookiePopover1El) cookiePopover1El.classList.add('popover--active');
  if ('checkBlockScroll' in Scroll) Scroll.checkBlockScroll();

  // if there is a iframe toggle, don't accept iframes for now
  if ($cookies) {
    for (let i = 0; i < $cookies.length; i++) {
      if ($cookies[i].type == 'iframes') {
        cookiesSetIframes = true;
        cookiesAcceptIframes = false;
      }
    }
  }
};

const closeCookies = () => {
  // console.log('closeCookies');
  if (cookiePopover1El) cookiePopover1El.classList.remove('popover--active');
  if (cookiePopover2El) cookiePopover2El.classList.remove('popover--active');
  if ('checkBlockScroll' in Scroll) Scroll.checkBlockScroll();
};

const checkReload = () => {
  // console.log('checkReload', $cookies);
  if ($cookies) {
    for (let i = 0; i < $cookies.length; i++) {
      if (
        $cookies[i].type == 'script'
        && $cookies[i].reload_page
        && $cookies[i].accepted
      ) {
        // reload page is needed for this cookie to work correctly and it is accepted
        // console.log('reload page needed');
        window.location.reload();
        return;
      }
    }
  }

  applyCookies();
};

const applyCookies = () => {
  // console.log('applyCookies');

  cookiesAcceptIframes = true;

  if ($cookies) {
    for (let i = 0; i < $cookies.length; i++) {
      if ($cookies[i].type == 'iframes') {
        cookiesSetIframes = true;

        if (!$cookies[i].accepted) {
          // don't accept iframes
          cookiesAcceptIframes = false;
        }
      } else if ($cookies[i].type == 'script') {
        if ($cookies[i].accepted) {
          // add script to page
          cookiesAddHTML($cookies[i].head);
          cookiesAddHTML($cookies[i].body);
        }
      }
    }
  }

  closeCookies();

  // console.log({cookiesSetIframes, cookiesAcceptIframes});

  cookiesDoSetIframes();
};

export const cookiesAddHTML = html => {
  // console.log('cookiesAddHTML', html);
  const elm = document.createElement('div');
  document.body.appendChild(elm);
  elm.innerHTML = html;

  Array.from(elm.querySelectorAll('script')).forEach(oldScript => {
    const newScript = document.createElement('script');
    Array.from(oldScript.attributes)
      .forEach(attr => newScript.setAttribute(attr.name, attr.value));
    newScript.appendChild(document.createTextNode(oldScript.innerHTML));
    oldScript.parentNode.replaceChild(newScript, oldScript);
  });
};

export const openIframes = () => {
  // console.log('openIframes', {cookiesAcceptIframes});
  if (typeof cookiesAcceptIframes === 'undefined' || cookiesAcceptIframes) {
    document.body.classList.add('body--iframes-accepted');
  } else {
    document.body.classList.remove('body--iframes-accepted');
  }
};

export const cookiesDoSetIframes = () => {
  // open iframes that were blocked
  if (cookiesSetIframes) {
    const blockedIframeEls = document.querySelectorAll('.blocked-iframe--visible');
    blockedIframeEls.forEach(blockedIframeEl => {
      const videoEmbedEl = blockedIframeEl.closest('.video-embed');
      // console.log({videoEmbedEl});
      if (videoEmbedEl && 'openVideoEmbed' in VideoEmbed) {
        VideoEmbed.openVideoEmbed(videoEmbedEl, false); // don't autoplay when accepting cookies after clicking play on a video, because that would be annoying
      }

      // embeds
      const embedEl = blockedIframeEl.closest('[data-code]');
      if (embedEl) {
        const code = embedEl.dataset.code;
        // console.log({code, cookiesAcceptIframes});
        if (code && cookiesAcceptIframes && !embedEl.querySelector('iframe')) {
          // Parse the HTML to separate script tags
          const temp = document.createElement('div');
          temp.innerHTML = code;
          
          // Insert all non-script content
          const scripts = temp.querySelectorAll('script');
          scripts.forEach(script => script.remove());
          embedEl.insertAdjacentHTML('afterbegin', temp.innerHTML);
          
          // Execute any script tags
          const parser = new DOMParser();
          const parsed = parser.parseFromString(code, 'text/html');
          parsed.querySelectorAll('script').forEach(script => {
            const newScript = document.createElement('script');
            Array.from(script.attributes)
              .forEach(attr => newScript.setAttribute(attr.name, attr.value));
            if (!script.src) newScript.textContent = script.textContent;
            embedEl.appendChild(newScript);
          });
          
          blockedIframeEl.classList.remove('blocked-iframe--visible');
        }
      }
    });

    if ($cookies) {
      for (let i = 0; i < $cookies.length; i++) {
        if ($cookies[i].type == 'iframes' && cookiesAcceptIframes) {
          // console.log({cookiesAcceptIframes}, $cookies[i]);
          cookiesAddHTML($cookies[i].script_tags);
        }
      }
    }

    openIframes();
  }
};